module.exports = {"231121100":"嫩江镇","231121101":"伊拉哈镇","231121102":"双山镇","231121103":"多宝山镇","231121104":"海江镇","231121105":"前进镇","231121106":"长福镇","231121107":"科洛镇","231121108":"霍龙门镇","231121202":"临江乡","231121206":"联兴乡","231121207":"白云乡","231121208":"塔溪乡","231121211":"长江乡","231121400":"多宝山铜矿","231121500":"九三管理局局直","231121501":"鹤山农场","231121502":"大西江农场","231121503":"尖山农场","231121504":"荣军农场","231121505":"红五月农场","231121506":"七星泡农场","231121507":"嫩江农场","231121508":"山河农场","231121509":"嫩北农场","231121510":"建边农场","231121581":"马铃薯原种繁殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231121.json
// module id = 883
// module chunks = 0